module.exports = __webpack_public_path__ + "img/bgForest.c83e6455.png";